import { createSelector } from "reselect";

const localidadesEntregaReducerDataSelector = state =>
    state.localidadEntregaReducer.getIn(["data"]).toJS();

export const localidadesEntregaDataSelector = createSelector(
    localidadesEntregaReducerDataSelector,
    (dataField) => {
        return {
            localidadesEntrega: dataField.localidadesEntrega || [],
            loading: dataField.loading,
            error: dataField.error,
        };
    }
);

export const localidadEntregaSeleccionadaSelector = createSelector(
    localidadesEntregaReducerDataSelector,
    (dataField) => {
        return dataField.localidadEntregaSeleccionada;
    }
);